// frontend/src/components/chat/patient-panel/IPASSSection.tsx
import { FC, useMemo } from 'react'
import { parseIPASS, IPASS_SECTIONS, SECTION_LABELS } from '../../../utils/ipassParser'
import type { IPASSSectionKey } from '../../../utils/ipassParser'

interface IPASSSectionProps {
  /** Raw text containing IPASS markers (from Casey's output or canvas Notes tab) */
  source?: string | null
}

const TAILWIND_COLORS: Record<IPASSSectionKey, string> = {
  I: 'border-red-400 text-red-400',
  S2: 'border-green-400 text-green-400',
  VD: 'border-teal-400 text-teal-400',
  A: 'border-orange-400 text-orange-400',
  S1: 'border-amber-400 text-amber-400',
  P: 'border-blue-400 text-blue-400',
}

export const IPASSSection: FC<IPASSSectionProps> = ({ source }) => {
  const sections = useMemo(() => {
    if (!source) return null
    const parsed = parseIPASS(source)
    return Object.keys(parsed).length > 0 ? parsed : null
  }, [source])

  if (!sections) {
    return (
      <div className="p-4 text-center text-sm text-muted-foreground">
        IPASS handoff not yet generated
      </div>
    )
  }

  return (
    <div className="space-y-3 p-2">
      {IPASS_SECTIONS.map(key => {
        const content = sections[key]
        const label = SECTION_LABELS[key]
        const colors = TAILWIND_COLORS[key]
        const [borderColor, textColor] = colors.split(' ')

        return (
          <div
            key={key}
            className={`border-l-2 ${borderColor} pl-3 ${!content ? 'opacity-40' : ''}`}
          >
            <h4 className={`text-xs font-semibold uppercase tracking-wide mb-1 ${textColor}`}>
              {label}
            </h4>
            {content ? (
              <div className="text-sm text-foreground/90 leading-relaxed whitespace-pre-wrap">
                {content}
              </div>
            ) : (
              <p className="text-xs text-muted-foreground italic">Pending...</p>
            )}
          </div>
        )
      })}
    </div>
  )
}
